export type PlancheShot = {
  emplacement: number;
  libelle: string;
  orientation: 'landscape' | 'portrait';
  flash: boolean;
  miroirHorizontal: boolean;
  miroirVertical: boolean;
  instruction: string;
  guideUrl: string;
  remplacementUrl: string;
  width: number;
  height: number;
  etiquettes: string[];
};

export type Planche = {
  id: number;
  libelle: string;
  photos: PlancheShot[];
};

const ASSET_ROOT = '/seances-photo';

function resolveAsset(url: string): string {
  if (url.startsWith('http')) return url;
  return `${ASSET_ROOT}${url}`;
}

export async function loadPlanche(id: number): Promise<Planche> {
  const res = await fetch(`${ASSET_ROOT}/planche${id}.json`);
  if (!res.ok) throw new Error(`Planche ${id} introuvable`);
  const raw = (await res.json()) as Omit<Planche, 'id'>;
  return {
    id,
    libelle: raw.libelle,
    photos: raw.photos.map((p) => ({
      ...p,
      guideUrl: resolveAsset(p.guideUrl),
      remplacementUrl: resolveAsset(p.remplacementUrl),
    })),
  };
}
